import { styled } from '@mui/material/styles'
import { Card, ListItem, InputBase, Typography } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { ArrowBack } from '@mui/icons-material'

export const SearchBoxStylesDiv = styled(Card)(({ theme }) => ({
  //Added
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.customBorderRadius.main,
  padding: '8px',
  //END Added
  minWidth: '250px',
  maxWidth: '320px',
  minHeight: '180px',
  maxHeight: '204px',
  overflowY: 'scroll',
  paddingLeft: '12px',
}))

export const SearchInputStylesDiv = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginTop: '10px',
  //Added
  padding: '2px 4px',
})

export const SearchInputBaseStyles = styled(InputBase)({
  width: '100%',
  overflow: 'auto',
  marginLeft: '10px',
})

export const SearchListStylesDiv = styled('div')({
  padding: '10px',
  cursor: 'pointer',
  paddingTop: 0,
  paddingLeft: 0,
})

export const SearchListItemStyle = styled(Typography)({
  marginTop: '10px',
  marginBottom: 10,
  textOverflow: 'ellipsis',
})

export const EmptySearchListItemStyle = styled(ListItem)(({ theme }) => ({
  color: theme.palette.grey[300],
  //added
  //justifyContent: 'center',
}))

export const SearchIconStyle = styled(SearchIcon)(({ theme }) => ({
  color: theme.palette.grey[400], //Theme.GREY_ICON
}))

export const BackIconStyle = styled(ArrowBack)(({ theme }) => ({
  color: theme.palette.primary.main,
}))

export const BackIconWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '20%',
  alignItems: 'center',
  color: theme.palette.primary.main,
  cursor: 'pointer',
}))

export const StyledInputBase = styled(InputBase)({
  marginLeft: '8px',
  flex: 1,
})
